import * as THREE from 'three';
import { GLTFLoader } from "three/examples/jsm/Addons.js";

export class Base3DPart {
    protected gltfLoader = new GLTFLoader();
    protected basePath: string;

    constructor(machineType: string, isMultiplePart: boolean = false, numberOfSlides?: number, basePath?: string) {
        if (basePath){
            this.basePath = basePath;
        } else {
            switch (machineType) {
                case 'Optica':
                    this.basePath = 'assets/models/optica';
                    if (numberOfSlides !== undefined && !isMultiplePart) {
                        numberOfSlides = Math.ceil(numberOfSlides);
                        switch (numberOfSlides) {
                            case 1:
                            case 2:
                                this.basePath = `${this.basePath}/machine-2`;
                                break;
                            case 3:
                            case 4:
                                this.basePath = `${this.basePath}/machine-4`;
                                break;
                            case 5:
                            case 6:
                                this.basePath = `${this.basePath}/machine-6`;
                                break;
                            case 7:
                            case 8:
                                this.basePath = `${this.basePath}/machine-8`;
                                break;
                            default:
                                this.basePath = `${this.basePath}/machine-2`;
                                break;
                        }
                    } else {
                        this.basePath = `${this.basePath}/parts`;
                    }
                    break;
                case 'Hyperion':
                    isMultiplePart ? this.basePath = 'assets/models/hyperion/parts' : this.basePath = 'assets/models/hyperion/machine-2';
                    break;
                default: // Feinx
                    this.basePath = 'assets/models/fenix';
                    if (numberOfSlides !== undefined && !isMultiplePart) {
                        switch (numberOfSlides) {
                            case 1:
                            case 2:
                                this.basePath = `${this.basePath}/machine-2`;
                                break;
                            case 3:
                            case 4:
                                this.basePath = `${this.basePath}/machine-4`;
                                break;
                            case 5:
                            case 6:
                                this.basePath = `${this.basePath}/machine-6`;
                                break;
                            case 7:
                            case 8:
                                this.basePath = `${this.basePath}/machine-8`;
                                break;
                            default:
                                this.basePath = `${this.basePath}/machine-2`;
                                break;
                        }
                    } else {
                        this.basePath = `${this.basePath}/parts`;
                    } 
                    break;
            }
        }
    }

    load(scene: THREE.Scene): void {
        // To be implemented by derived classes
    }
}